import React, { useRef, useState } from 'react';
import LoopVideo from './LoopVideo';
import prefersReducedMotion from './prefersReducedMotion';

/**
 * The launch film as a full-bleed, feathered strip of the page (no player
 * box). Plays muted in view; a small control restarts it from the top.
 */
export default function FilmPlayer({ className = '' }) {
  const videoRef = useRef(null);
  const [reduced] = useState(prefersReducedMotion);
  return (
    <div className={`pnp-film ${className}`.trim()}>
      <LoopVideo
        name="film"
        feather="edges"
        videoRef={videoRef}
        label="Pick 'N Pray launch film: picking a UFC card, the live leaderboard, Corner Chat and badges"
      />
      {!reduced ? (
        <button
          type="button"
          className="pnp-btn pnp-btn-ghost pnp-film-replay"
          onClick={() => {
            const v = videoRef.current;
            if (!v) return;
            v.currentTime = 0;
            v.play().catch(() => {});
          }}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1.5a4.5 4.5 0 104.3 5.9" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><path d="M6 0v3.2L8.4 1.6z" fill="currentColor" /></svg>
          Replay film
        </button>
      ) : null}
    </div>
  );
}
